import React, { Fragment } from "react";
import { orderBy } from "lodash";
import { Box, Divider, Stack } from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import StyledTableCell from "../tabel-component/StyledTableCell";
import DiffTableCell from "../tabel-component/DiffTableCell";
import ValueItem from "../tabel-component/ValueItem";
import { dataChangedRowColorMap } from "../../constants/colors";

export default function VerticalSignificanceInReviewTable({ data }) {
  return (
    <Fragment>
      <Toolbar>
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          In Review
        </Typography>
      </Toolbar>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <StyledTableCell align="center" sx={{ width: "1vw" }}>
              UID
            </StyledTableCell>
            <StyledTableCell align="center" sx={{ width: "1vw" }}>
              OBJECT NAME
            </StyledTableCell>
            <StyledTableCell align="center" sx={{ width: "2vw" }}>
              <Box>LATITUDE</Box>
              <Stack
                direction="row"
                justifyContent="center"
                divider={<Divider orientation="vertical" flexItem />}
                spacing={1}
              >
                <Box sx={{ typography: "caption" }}>NEW</Box>
                <Box sx={{ typography: "caption" }}>OLD</Box>
              </Stack>
            </StyledTableCell>
            <StyledTableCell align="center" sx={{ width: "2vw" }}>
              <Box>LONGITUDE</Box>
              <Stack
                direction="row"
                justifyContent="center"
                divider={<Divider orientation="vertical" flexItem />}
                spacing={1}
              >
                <Box sx={{ typography: "caption" }}>NEW</Box>
                <Box sx={{ typography: "caption" }}>OLD</Box>
              </Stack>
            </StyledTableCell>
            <StyledTableCell align="center" sx={{ width: "1vw" }}>
              <Stack>
                <Box>TOP ELEV. IN m. (EGM 08)</Box>
                <Stack
                  direction="row"
                  justifyContent="center"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={1}
                >
                  <Box sx={{ typography: "caption" }}>NEW</Box>
                  <Box sx={{ typography: "caption" }}>OLD</Box>
                  <Box sx={{ typography: "caption" }}>DIFF</Box>
                </Stack>
              </Stack>
            </StyledTableCell>
            <StyledTableCell align="center" sx={{ width: "1vw" }}>
              <Stack>
                <Box>DISTANCE IN M. FROM NEW ARP</Box>
                <Stack
                  direction="row"
                  justifyContent="center"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={1}
                >
                  <Box sx={{ typography: "caption" }}>NEW</Box>
                  <Box sx={{ typography: "caption" }}>OLD</Box>
                  <Box sx={{ typography: "caption" }}>DIFF</Box>
                </Stack>
              </Stack>
            </StyledTableCell>
            <StyledTableCell align="center" sx={{ width: "1vw" }}>
              <Stack>
                <Box>MAG. BRG.FROM NEW ARP</Box>
                <Stack
                  direction="row"
                  justifyContent="center"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={1}
                >
                  <Box sx={{ typography: "caption" }}>NEW</Box>
                  <Box sx={{ typography: "caption" }}>OLD</Box>
                  <Box sx={{ typography: "caption" }}>DIFF</Box>
                </Stack>
              </Stack>
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orderBy(data, ["uid1"], ["asc"]).map((row, i) => {
            return (
              <TableRow
                key={i}
                sx={{
                  background: dataChangedRowColorMap[row.result] ?? "#FFFFFF",
                }}
              >
                <DiffTableCell align="center">{row["uid1"]}</DiffTableCell>
                <DiffTableCell align="center">
                  {row["object1"] || "-"}
                </DiffTableCell>
                <DiffTableCell align="center" isdiff={row["latdev"]}>
                  <Stack
                    direction="row"
                    justifyContent="center"
                    divider={<Divider orientation="vertical" flexItem />}
                    spacing={1}
                  >
                    <ValueItem value={row["latitude1"]} />
                    <ValueItem value={row["latitude2"]} />
                  </Stack>
                </DiffTableCell>
                <DiffTableCell align="center" isdiff={row["longdev"]}>
                  <Stack
                    direction="row"
                    justifyContent="center"
                    divider={<Divider orientation="vertical" flexItem />}
                    spacing={1}
                  >
                    <ValueItem value={row["longitude1"]} />
                    <ValueItem value={row["longitude2"]} />
                  </Stack>
                </DiffTableCell>
                <DiffTableCell
                  align="center"
                  isdiff={Boolean(row["top_elevdiff"])}
                >
                  <Stack
                    direction="row"
                    justifyContent="center"
                    divider={<Divider orientation="vertical" flexItem />}
                    spacing={1}
                  >
                    <ValueItem value={row["top_elev1"]} />
                    <ValueItem value={row["top_elev2"]} />
                    <ValueItem value={row["top_elevdiff"]} />
                  </Stack>
                </DiffTableCell>
                <DiffTableCell
                  align="center"
                  isdiff={Boolean(row["distancediff"])}
                >
                  <Stack
                    direction="row"
                    justifyContent="center"
                    divider={<Divider orientation="vertical" flexItem />}
                    spacing={1}
                  >
                    <ValueItem value={row["distance1"]} />
                    <ValueItem value={row["distance2"]} />
                    <ValueItem value={row["distancediff"]} />
                  </Stack>
                </DiffTableCell>
                <DiffTableCell
                  align="center"
                  isdiff={Boolean(row["mag_brgdiff"])}
                >
                  <Stack
                    direction="row"
                    justifyContent="center"
                    divider={<Divider orientation="vertical" flexItem />}
                    spacing={1}
                  >
                    <ValueItem value={row["mag_brg1"]} />
                    <ValueItem value={row["mag_brg2"]} />
                    <ValueItem value={row["mag_brgdiff"]} />
                  </Stack>
                </DiffTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Fragment>
  );
}
